import React from 'react';
import { canScanSponsors, researchFreshness, shortDate, type ResearchCoverage } from '../../utils/researchFreshness';
import './ResearchFreshness.css';

/** The save date is a flat stamp pressed inline on the file: ink while it is recent, amber
 *  once it needs a re-read. A stamp records what happened, so a file with no save date is
 *  NOT READ and one with a platform missing is PARTIAL — never a guess at completeness. `busy` only
 *  marks the slot; the button beside it is what reads 'Checking…'. */
export default function ResearchFreshness({coverage, busy = false, compact = false}: {coverage:ResearchCoverage[]; busy?:boolean; compact?:boolean}) {
  const {state, savedAt} = researchFreshness(coverage);
  const supported = coverage.filter(c => canScanSponsors(c.platform));
  const dated = supported.filter(c => c.lastScraped && Number.isFinite(Date.parse(c.lastScraped)));
  const title = coverage.map(c => {
    const time = c.lastScraped && Number.isFinite(Date.parse(c.lastScraped)) ? new Date(c.lastScraped).toLocaleString() : 'Date unavailable';
    return `${c.platform}: ${time}`;
  }).join('\n') + '\nSaved data is not a complete check of all recent posts. Open the creator’s platform cards for its refresh schedule.';
  const word = state === 'profile-only' ? 'Profile only'
    : state === 'unknown' ? (dated.length ? 'Partial' : 'Not read')
    : `${supported.length > 1 ? 'Oldest save' : 'Saved'} ${shortDate(savedAt)}`;
  const amber = state === 'aging' || state === 'unknown';
  return (
    <span className={`br-freshness br-freshness--${busy ? 'checking' : state}`} title={title}>
      <span className="br-caption" style={{ fontWeight: 700, fontSize: 10, letterSpacing: '.08em', textTransform: 'uppercase', color: amber ? 'var(--amber)' : 'var(--ink-2)' }}>{word}</span>
      <span className={compact ? 'sr-only' : 'br-freshness__coverage'}>
        {state === 'profile-only' ? 'Sponsor scanning is not available for this platform.' : 'Saved snapshot. Platform cards show check status and scheduled updates.'}
      </span>
    </span>
  );
}
